import { Box } from '@chakra-ui/react';
import useAutoformMetadata from './hooks/useAutoformMetadata';
import AutoformTabs from './AutoformTabs';
import AutoformTableContainer from './AutoformTableContainer';
import AutoformItemFields from './AutoformItemFields';
import ItemTopHeaderContainer from './ItemTopHeaderContainer';
import ExpandableItemWrapper from '../layout/ExpandableItemWrapper';
import ItemFormContainer from './ItemFormContainer';
import { getInputFormName } from './utils/autoformUtils';
import Error from '../utils/Error';
import DefinitionsSkeleton from '../utils/DefinitionsSkeleton';
import useAutoformReloadItemData from './hooks/useAutoformReloadItemData';

const Level2Autoform = ({
    onNodeRename,
    onNodeItemDelete,
    tableId,
    itemId,
    portfolioItem,
    onNodeOwnershipPercentageUpdate,
}) => {
    const { metadata, hierarchicalTables } = useAutoformMetadata();
    const { isLoading, loadingError } = useAutoformReloadItemData(tableId, itemId);

    if (!metadata) return 'Loading...';
    if (hierarchicalTables.level1.length === 0) return 'No level 1 table'; //  TODO: Handle errors
    if (hierarchicalTables.level2.length === 0) return 'No level 2 table'; // TODO:  Handle errors
    const level1TableId = hierarchicalTables.level1[0]?.id;

    return (
        <>
            {isLoading ? (
                <DefinitionsSkeleton />
            ) : loadingError ? (
                <Box m={6}>
                    <Error primaryId="common_error" secondaryId="common_loading_error" />
                </Box>
            ) : (
                <ExpandableItemWrapper>
                    <ItemFormContainer onNodeRename={onNodeRename}>
                        <ItemTopHeaderContainer
                            tableId={level1TableId}
                            onNodeItemDelete={onNodeItemDelete}
                            portfolioItem={portfolioItem}
                            onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                        />

                        <Box px={6}>
                            <AutoformItemFields tableId={level1TableId} getInputFormName={getInputFormName} />

                            <AutoformTabs
                                renderTabPanel={(table) => (
                                    <AutoformTableContainer schemaCode={metadata.schemaCode} tableId={table.id} />
                                )}
                                tables={hierarchicalTables.level2}
                            />
                        </Box>
                    </ItemFormContainer>
                </ExpandableItemWrapper>
            )}
        </>
    );
};

export default Level2Autoform;
